import { useEffect } from 'react';

import styles from '../../styles/modules/layout/App.module.scss';

import Main from './Main';
import Faq from '../faq/Faq';
import Header from './Header';
import Game from '../game/Game';
import Tasks from '../tasks/Tasks';
import FaqList from '../faq/FaqList';
import ModalRoot from '../modal/ModalRoot';
import Modal from '../modal/Modal';

import { usePromoStore } from '../../store/userPromoStore';
import { useConfigStore } from '../../store/useConfigStore';

const App = () => {
	const loadPromoFromUrl = usePromoStore((s) => s.loadPromoFromUrl);
	const openModal = useConfigStore((s) => s.openModal);

	useEffect(() => {
		loadPromoFromUrl();
	}, [loadPromoFromUrl]);

	useEffect(() => {
		const timer = setTimeout(() => {
			openModal(Modal);
		}, 1500);

		return () => clearTimeout(timer);
	}, [openModal]);

	return (
		<div className={styles.app}>
			<div className={styles.main}>
				<div className='container'>
					<div className={styles.first}>
						<Header />
						<Main />
					</div>

					<div className='flex-container'>
						<Game />
						<Tasks />
						<Faq />
					</div>
				</div>

				<FaqList />
			</div>

			<ModalRoot />
		</div>
	);
};

export default App;
